import { useState, useEffect } from 'react';
import QRCode from 'qrcode';

export interface QRCodeViewProps {
  value: string;
  size?: number;
  className?: string;
  alt?: string;
}

export function QRCodeView({
  value,
  size = 120,
  className = '',
  alt = 'QR Code',
}: QRCodeViewProps) {
  const [dataUrl, setDataUrl] = useState<string>('');

  useEffect(() => {
    if (!value) return;
    let isMounted = true;

    QRCode.toDataURL(value, {
      width: size * 2, // High DPI rendering
      margin: 1,
      color: {
        dark: '#0f172a',
        light: '#ffffff',
      },
    })
      .then((url) => {
        if (isMounted) {
          setDataUrl(url);
        }
      })
      .catch((err) => {
        console.error('Failed to generate QR code:', err);
      });

    return () => {
      isMounted = false;
    };
  }, [value, size]);

  if (!dataUrl) {
    return (
      <div
        className={`flex items-center justify-center bg-muted/20 border border-border rounded text-2xs text-muted-foreground animate-pulse ${className}`}
        style={{ width: size, height: size }}
      >
        Generating QR...
      </div>
    );
  }

  return (
    <img
      src={dataUrl}
      alt={alt}
      width={size}
      height={size}
      className={`qr-img object-contain shrink-0 rounded ${className}`}
      style={{ width: `${size}px`, height: `${size}px` }}
    />
  );
}
